var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.open
    ? _c(
        "div",
        {
          staticClass: "wkb-assistant-progress-overlay",
          attrs: {
            role: "alertdialog",
            "aria-modal": "true",
            "aria-live": "assertive",
            "aria-busy": "true",
            "aria-label": _vm.message || "Running assistant action",
          },
        },
        [
          _c("div", { staticClass: "wkb-assistant-progress-card" }, [
            _c("span", {
              staticClass: "wkb-assistant-progress-spinner",
              attrs: { "aria-hidden": "true" },
            }),
            _c("p", { staticClass: "wkb-assistant-progress-message" }, [
              _vm._v(_vm._s(_vm.message || "Running…")),
            ]),
            _c("p", { staticClass: "wkb-assistant-progress-note" }, [
              _vm._v(" Graph changes are paused while this action runs. "),
            ]),
          ]),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }